<template>
  <main
  v-loading="loading">
    <h3 v-html="$t('SelectAtricleAirzone')" />
        <el-row>
      <el-col
      v-for="(article, key) in articles"
      :key="key"
      :lg="{span:7,offset:3}"
      :sm="{span:14,offset:0}"
      class="caja">
        <div
        @click="
          $emit(
          'setArticleType',
          {'articleType':
          {value: article.reference, id: 2}
          })">
          <el-col>
            <p v-html="$t(`${compatibilityType}.articles.${article.reference}.title`)" class="title"/>
          </el-col>
          <el-col>
            <img :src="$t(`${compatibilityType}.articles.${article.reference}.img`)" class="typeImages"/>
          </el-col>
          <el-col v-if="$t(`${compatibilityType}.articles.${article.reference}.desc`) !== ''">
            <p v-html="$t(`${compatibilityType}.articles.${article.reference}.desc`)" class="desc"/>
          </el-col>
        </div>
      </el-col>
    </el-row>
  </main>
</template>

<script>
import CompatibilityServices from '@/api/CompatibilityServices';
import LoaderMixin from '@/mixins/Loader.mixin';

export default {
  name: 'SelectArticleType',
  mixins: [LoaderMixin],
  props: {
    appMarket: {
      type: String,
      default: '',
    },
    appLocale: {
      type: String,
      default: '',
    },
    compatibilityType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      articles: {},
    };
  },
  methods: {
    async getApi() {
      const requestHeaders = {
        headers: {
          'app-market': this.appMarket,
          'app-locale': this.appLocale,
          apiKey: process.env.VUE_APP_APIKEY,
        },
      };
      const response = await CompatibilityServices.getArticleTypes(
        requestHeaders,
        this.compatibilityType,
      );
      this.articles = response.data.body.compatibility_type.article_types;
    },
  },
  mounted() {
    this.getApi();
  },
};
</script>

<style scoped lang="scss">
.typeImages{
  max-width: 50%;
}
.caja {
  border: 2px #7c8486 solid;
  border-radius: 25px;
  p {
    padding: 0px 10px 0px 10px;
  }
  cursor: pointer;
  padding: 10px;
  margin-top: 20px;
}
@media (max-width: 767px){
  .caja {
    margin-top: 25px;
  }
}
.title{
  text-transform: uppercase;
  font-weight: 300;
  font-size: 18px;

}
.caja:hover{
  border-color: #007297;
}
.desc {
  min-height: 134px;
}
</style>
